<template>
  <div class="collapsible-text">
    <div
      ref="textContentContainer"
      :style="contentStyles"
      class="collapsible-text-content"
    >
      <div
        ref="textContent"
        :style="`line-height: ${lineHeight}px;`"
        class="text-content"
      >
        <div v-html="content" style="display: inline" />
      </div>
    </div>
    <div v-if="showActions" :style="actionStyles" class="collapsible-actions">
      <button v-if="isExpanded" class="collapse-button" @click="collapse">
        {{ collapseButtonText }}
      </button>
      <button v-else class="expand-button" @click="expand">
        {{ expandButtonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleText',

  props: {
    /**
     * Read less button text
     *
     * @type {string}
     */
    collapseButtonText: {
      type: String,
      default: 'Read Less'
    },
    /**
     * Content text
     *
     * @type {string}
     */
    content: {
      type: String,
      required: true
    },
    /**
     * Read more button text
     *
     * @type {string}
     */
    expandButtonText: {
      type: String,
      default: 'Read More'
    },
    /**
     * Direct of where the button should align
     *
     * @type {string}
     */
    buttonAlignment: {
      type: String,
      default: 'left'
    },
    /**
     * Max number of line to shown when collapsed
     *
     * @type {number}
     */
    maxLines: {
      type: Number,
      default: 3
    },
    /**
     * Line height of the content
     *
     * @type {number}
     */
    lineHeight: {
      type: Number,
      default: 20
    }
  },

  data() {
    return {
      contentLines: 0,
      isExpanded: false,
      isOverflowByHeight: false,
      isOverflowByLines: false
    }
  },

  computed: {
    actionStyles() {
      return {
        'text-align': this.buttonAlignment
      }
    },
    contentStyles() {
      if (this.maxLines === 0) {
        return {
          display: this.isExpanded ? 'block' : 'none'
        }
      } else {
        return {
          display: '-webkit-box',
          '-webkit-box-orient': 'vertical',
          overflow: 'hidden',
          '-webkit-line-clamp': this.isExpanded ? 'unset' : this.maxLines
        }
      }
    },
    showActions() {
      return (
        this.maxLines === 0 || this.isOverflowByLines || this.isOverflowByHeight
      )
    }
  },

  mounted() {
    this.checkOverflow()
  },

  updated() {
    this.checkOverflow()
  },

  methods: {
    collapse() {
      this.isExpanded = false
    },
    expand() {
      this.isExpanded = true
    },
    checkOverflow() {
      const scrollHeight = this.$refs.textContentContainer.scrollHeight
      const maxHeight = this.lineHeight * this.maxLines
      this.lines = this.$refs.textContent.getClientRects().length

      this.isOverflowByLines = this.lines > this.maxLines
      this.isOverflowByHeight = scrollHeight > maxHeight
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse-button,
.expand-button {
  background-color: unset;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 0;
  text-decoration: underline;

  &:focus {
    outline: 0;
  }
}
</style>
